import * as React from "react";

import { cn } from "@/lib/utils";

export interface DatePickerProps {
  /** Value as YYYY-MM-DD string */
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  id?: string;
  /** Minimum selectable date as YYYY-MM-DD */
  min?: string;
  /** Maximum selectable date as YYYY-MM-DD */
  max?: string;
}

export function DatePicker({
  value,
  onChange,
  className,
  disabled,
  id,
  min,
  max,
}: DatePickerProps) {
  const dateStr = value && value.length > 10 ? value.slice(0, 10) : value;

  return (
    <input
      type="date"
      id={id}
      value={dateStr}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      min={min}
      max={max}
      className={cn(
        "h-9 rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm max-md:text-base!",
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
    />
  );
}
